import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
import { theme } from '@styles/theme';
const spin = keyframes `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const sizeMap = {
    sm: '16px',
    md: '24px',
    lg: '40px',
};
const borderWidthMap = {
    sm: '2px',
    md: '3px',
    lg: '4px',
};
const SpinnerElement = styled.div `
  width: ${({ $size }) => sizeMap[$size]};
  height: ${({ $size }) => sizeMap[$size]};
  border: ${({ $size }) => borderWidthMap[$size]} solid ${theme.colors.background.tertiary};
  border-top-color: ${({ $color }) => $color};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;
export function Spinner({ size = 'md', color = theme.colors.accent.primary }) {
    return _jsx(SpinnerElement, { "$size": size, "$color": color, role: "status", "aria-label": "Loading" });
}
// Full page loading spinner
const FullPageContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${theme.colors.background.primary};
`;
export function FullPageSpinner() {
    return (_jsx(FullPageContainer, { children: _jsx(Spinner, { size: "lg" }) }));
}
